import { mapProps, compose } from 'recompose';
import DiscountTag from './DiscountTag';

const configureProps = mapProps(({ discount }) => {
  if (discount) {
    return { text: `${discount}% OFF` };
  }
  return null;
});

export default compose(configureProps)(DiscountTag);
